export enum EOtpType {
  Register = 'Register',
  Confirm = 'Confirm',
  Reset = 'Reset',
}
